import { render, staticRenderFns } from "./OrganisationListTable.vue?vue&type=template&id=3137ad6d&"
import script from "./OrganisationListTable.vue?vue&type=script&lang=js&"
export * from "./OrganisationListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports